/**
 * Lógica pura do tema claro/escuro (Design.md §3.1). Mantida fora do
 * ThemeProvider para ser testável em node, sem DOM nem React. O provider
 * consome estas funções e aplica `data-theme` na raiz.
 */
export type Theme = "light" | "dark";

export const THEMES: readonly Theme[] = ["light", "dark"];

export const DEFAULT_THEME: Theme = "light";

const STORAGE_KEY = "ficc-theme";

export function isTheme(value: unknown): value is Theme {
  return value === "light" || value === "dark";
}

/** Próximo tema no toggle (alterna claro ↔ escuro). */
export function nextTheme(theme: Theme): Theme {
  return theme === "light" ? "dark" : "light";
}

/** Resolve o tema inicial: valor salvo > preferência do SO > padrão. */
export function resolveInitialTheme(
  stored: string | null,
  prefersDark: boolean
): Theme {
  if (isTheme(stored)) {
    return stored;
  }
  return prefersDark ? "dark" : DEFAULT_THEME;
}

export function readStoredTheme(storage: Pick<Storage, "getItem">): Theme | null {
  const raw = storage.getItem(STORAGE_KEY);
  return isTheme(raw) ? raw : null;
}

export function storeTheme(
  storage: Pick<Storage, "setItem">,
  theme: Theme
): void {
  storage.setItem(STORAGE_KEY, theme);
}
